import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { Header } from 'foundations-components/transitional/components/Header';
import { SEARCH_BAR_INLINE_SIZE } from '../constants/searchBar';
import { StorefrontTabNav } from '../navigation/components/StorefrontTabNav';
import { SearchBar } from '../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './headers/ManageBuildDropdowns';
import { PageCallouts } from '../hero/components/PageCallouts';
import { useGates } from '../hooks/useGates';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontDashboardWithTabs({
  children,
  interleaveBanners = false
}) {
  const {
    workflowTemplatesPhase2
  } = useGates();
  return /*#__PURE__*/_jsxs(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(Header, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.title"
      }),
      tabs: workflowTemplatesPhase2 ? /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        gap: "500",
        children: [/*#__PURE__*/_jsx(View, {
          flexGrow: 1,
          children: /*#__PURE__*/_jsx(StorefrontTabNav, {})
        }), /*#__PURE__*/_jsx(ManageBuildDropdowns, {})]
      }) : /*#__PURE__*/_jsx(StorefrontTabNav, {}),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "500",
        children: [!workflowTemplatesPhase2 && /*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(View, {
          inlineSize: SEARCH_BAR_INLINE_SIZE,
          maxInlineSize: "100%",
          flexShrink: 0,
          children: /*#__PURE__*/_jsx(SearchBar, {})
        })]
      })
    }),
    children: [/*#__PURE__*/_jsx(PageCallouts, {
      showBanners: !interleaveBanners
    }), children]
  });
}